import { ApiClient } from "client/base";
import { isAWSPresignedUrl, isAzurePresignedUrl } from "types/dataset";
import { sendAWSPresignedRequest, sendAzurePresignedRequest, sendGCPPresignedRequest } from "utils/cloud/presigned_url";
import { tableFromArrayBuffer, toTypedArray } from "@/utils/arrow";
export function uploadFile(file, upload) {
    if (isAWSPresignedUrl(upload.presigned_url)) {
        return sendAWSPresignedRequest(file, upload.presigned_url);
    }
    else if (isAzurePresignedUrl(upload.data_url)) {
        return sendAzurePresignedRequest(file, upload.presigned_url);
    }
    else {
        return sendGCPPresignedRequest(file, upload.presigned_url);
    }
}
export class CloudDatasetClient extends ApiClient {
    account;
    constructor(base, account) {
        super(base);
        this.account = account;
    }
    uploadDataset(file, upload) {
        return uploadFile(file, upload);
    }
    initiateDatasetProcessing(schemaMonitorId, datasetsArr) {
        const params = {
            // Yes this has to be capital "A" Action
            Action: "explore_datasource",
            dataset_ids: datasetsArr,
            schema_monitor_id: schemaMonitorId
        };
        return this.base.post("v1/launchfunc2", params);
    }
    getErrorNotebookUrls(id) {
        return this.base.get(`v1/notebooks/datasets/${id}`);
    }
    getDatasetPivotTables(datasetId, max_order = 2) {
        return this.getDatasetPivotTablesMetadata(datasetId).then((metadata) => this.getDatasetPivotTablesSubset(datasetId, { max_order }).then((tables) => ({
            ...metadata,
            tables
        })));
    }
    getDatasetPivotTablesMetadata(datasetId) {
        return this.base.get(`v1/datasets/${datasetId}/pivot_tables`);
    }
    _getDatasetPivotTablesSubsetChunks(datasetId, payload, chunkIndex = 0) {
        return this.base
            .makeRequestRaw("POST", `v1/datasets/${datasetId}/pivot_tables`, {
            ...payload,
            chunk_index: chunkIndex
        })
            .then((response) => {
            return response.blob().then((blob) => {
                if (blob.size == 0) {
                    return new Response(blob, {
                        headers: response.headers,
                        status: response.status,
                        statusText: response.statusText
                    });
                }
                return this._getDatasetPivotTablesSubsetChunks(datasetId, payload, chunkIndex + 1)
                    .then((next) => next.blob())
                    .then((nextBlob) => new Response(new Blob([blob, nextBlob], { type: blob.type }), {
                    headers: response.headers,
                    status: response.status,
                    statusText: response.statusText
                }));
            });
        });
    }
    _getDatasetPivotTablesSubsetChunked(datasetId, payload) {
        if (this.account.type == "GCP") {
            return this.base.makeRequestRaw("POST", `v1/datasets/${datasetId}/pivot_tables`, payload);
        }
        return this._getDatasetPivotTablesSubsetChunks(datasetId, payload);
    }
    getDatasetPivotTablesSubset(datasetId, payload) {
        return this._getDatasetPivotTablesSubsetChunked(datasetId, payload).then((response) => {
            const contentType = response.headers.get("Content-Type");
            if (contentType == "application/json") {
                return response.json();
            }
            else if (contentType != "application/vnd.apache.arrow.stream") {
                throw Error(`unexpected content type: ${contentType}`);
            }
            return response.arrayBuffer().then((data) => {
                const table = tableFromArrayBuffer(data);
                const rows = table.toArray();
                const output = new Array(rows.length);
                for (let i = 0; i < rows.length; i++) {
                    output[i] = rows[i].toJSON();
                    output[i].ids = output[i].ids.toJSON();
                    output[i].n = toTypedArray(output[i].n.toArray());
                    if (output[i].n_null !== undefined) {
                        output[i].n_null = toTypedArray(output[i].n_null.toArray());
                    }
                    if (output[i].sum === undefined) {
                        output[i].sum = output[i].n;
                    }
                    else {
                        output[i].sum = toTypedArray(output[i].sum.toArray());
                    }
                    if (output[i].sum_2 === undefined) {
                        output[i].sum_2 = output[i].sum;
                    }
                    else {
                        output[i].sum_2 = toTypedArray(output[i].sum_2.toArray());
                    }
                }
                return output;
            });
        });
    }
}
